var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChartPie = function SvgChartPie(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.45 13.27a4 4 0 1 1 2.75 7.51 46.02 46.02 0 1 0 58.82 59.55 4 4 0 0 1 7.48 2.84 54.01 54.01 0 1 1-69.05-69.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 2a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h56a4 4 0 0 0 4-4A60 60 0 0 0 66 2m4 8.15.26.02a52.01 52.01 0 0 1 47.57 47.57l.02.26H70z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChartPie);
export default ForwardRef;